import debounce from '../utilities/debounce';

window.pardotFormLightboxInstances = {};

// a posted message from the contained document within a pardot iframe
const handleMessage = (e) => {

    const shouldUpdate = (formId, height) => {
        const forms = window.pardotFormLightboxInstances;
        if( !forms[formId] || forms[formId] && forms[formId].height !== height )
        {
            return true;
        }
        return false;
    }

    // if( !e.data.hello ) {
    //     console.log(e.data);
    // }

    // if this posted event contains a formId and height
    if (e.data && e.data.formId && e.data.height )
    {
        // identify any frames by the provided ID
        const iframes = document.querySelectorAll(`iframe[src*="${e.data.formId}"]`);
        if( iframes )
        {
            // resize, data updates and events will be restricted so each occurs when 
            // either the formId is being added for the first time, or when height has changed
            if( shouldUpdate(e.data.formId, e.data.height) )
            {
                for(let i=0; i<iframes.length; i++)
                {
                    // console.log('aimmsPardotIframe: resizing iframe formId ', e.data.formId, ' with height ', e.data.height);

                    // resize the iframe
                    iframes[i].style.height = e.data.height + 'px';

                    // add/update form data to the map
                    window.pardotFormLightboxInstances[e.data.formId] = {
                        formId: e.data.formId,
                        height: e.data.height
                    }

                    // dispatch an event so that lightbox instances can grow according to the new height of their children
                    const event = new CustomEvent('onPardotFormHeightUpdated', { detail: {
                        formId: e.data.formId,
                        height: e.data.height
                    }});

                    // post
                    window.dispatchEvent(event);
                }
            }
        }
    }
}

const handleMessageDebounced = debounce((e) => handleMessage(e), 500);

window.addEventListener('message', e => { handleMessageDebounced(e) });

